// extracted by mini-css-extract-plugin
export default {"body":"blog_body__o3ggN","top":"blog_top__y6lzD","inputBox":"blog_inputBox__uwCFl","filterBox":"blog_filterBox__YPzCP"};